export const business = {
  name: 'MW Stewart Construction',
  tagline: 'Serving Western Canada Since 1988',
  subTagline: 'Family Run Business',
  established: 1988,
  phone: '+1 (587) 433-4213',
  phoneRaw: '+15874334213',
  address: '3545 32 Avenue NE, Calgary, Alberta T1Y 6M6',
  addressShort: 'Calgary, Alberta',
  hours: 'Mon – Fri: 7:00 AM – 6:00 PM',
  hoursWeekend: 'Sat: 8:00 AM – 2:00 PM',
};

export const services = [
  {
    id: 'hot-asphalt-paving',
    title: 'Hot Asphalt Paving',
    short: 'Long-lasting asphalt surfaces for driveways, lots & roads.',
    description:
      'Asphalt paving is a sure way to have high-quality, long-lasting surfaces. MW Stewart Construction works on projects of all sizes, from residential driveways to large commercial lot resurfacing. We guarantee that the project will be completed quickly and easily. Our team is made up of specially trained and professional contractors who use cutting-edge equipment. We also provide asphalt repair and sealing services, extending the life of your pavement and increasing the curb appeal of your property.',
    bullets: [
      'Residential driveways',
      'Commercial parking lots',
      'Roads & subdivisions',
      'Asphalt repair & overlays',
    ],
    image: '/images/project-1.jpg',
  },
  {
    id: 'protective-seal-coating',
    title: 'Protective Seal Coating',
    short: 'Restore and protect the asphalt around your home or business.',
    description:
      'With a professionally applied pavement seal coating in Western Canada, you can restore the integrity of the asphalt and blacktop around your home or business. Since 1988, Canadian property owners have relied on MW Stewart Construction products, expertise, and service. Our sealcoating ensures superior performance and durability for the largest commercial lots, city streets, and driveways. With a variety of sealcoating applications, we can replenish damaged pavement binder. Furthermore, our special-graded composite can be tailored to your specific requirements.',
    bullets: [
      'Replenishes damaged pavement binder',
      'Fuel & slip resistance options',
      'Custom composite grades',
      'Extends pavement life 3–5x',
    ],
    image: '/images/project-3.jpg',
  },
  {
    id: 'hot-rubberized-crack-sealing',
    title: 'Hot Rubberized Crack Sealing',
    short: 'Stop water damage at the source with hot-applied rubberized sealant.',
    description:
      'Cracks are the #1 cause of asphalt failure. Our hot rubberized crack sealing penetrates deep into existing cracks, bonds with the surrounding pavement, and remains flexible through the harshest Western Canadian winters. This preventative service can add 10+ years to the life of your asphalt at a fraction of the cost of resurfacing.',
    bullets: [
      'Prevents water infiltration',
      'Flexible in -40°C to +40°C',
      'Stops freeze–thaw damage',
      'Cost-effective preventative care',
    ],
    image: '/images/project-7.jpg',
  },
  {
    id: 'line-painting-striping',
    title: 'Line Painting & Striping',
    short: 'Fresh, durable lines for parking lots and traffic management.',
    description:
      'Sharp, highly-visible line painting for commercial parking lots, warehouses, schools and municipalities. We use commercial-grade traffic paint that stands up to Canadian winters and heavy use.',
    bullets: [
      'Parking stalls & arrows',
      'Handicap & fire lanes',
      'Warehouse floor markings',
      'Reflective bead options',
    ],
    image:
      'https://images.unsplash.com/photo-1604275291560-55f54cec0e4d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200',
  },
  {
    id: 'asphalt-repair-patching',
    title: 'Asphalt Repair & Patching',
    short: 'Targeted repairs that extend the life of your existing asphalt.',
    description:
      'Potholes, alligator cracking and broken edges are repaired using hot-mix asphalt and infrared techniques for a seamless finish that lasts.',
    bullets: [
      'Pothole repair',
      'Infrared patching',
      'Edge repair & reshaping',
      'Speed bump installation',
    ],
    image: '/images/project-2.jpg',
  },
  {
    id: 'site-grading-prep',
    title: 'Site Grading & Preparation',
    short: 'A solid base is the secret to asphalt that lasts decades.',
    description:
      'Before any paving begins, we ensure proper grading, drainage and compaction of the gravel base. A great surface starts with a great foundation.',
    bullets: [
      'Excavation & grading',
      'Gravel base preparation',
      'Drainage solutions',
      'Compaction testing',
    ],
    image: '/images/project-6.jpg',
  },
];

// Service area — Calgary, Alberta only
export const serviceAreas = [
  {
    province: 'Alberta',
    cities: ['Calgary'],
  },
];

// Recent client projects (delivered to MW Stewart by clients)
export const galleryImages = [
  { src: '/images/project-1.jpg', caption: 'Recent Client Project — Asphalt Paving' },
  { src: '/images/project-2.jpg', caption: 'Recent Client Project — Driveway' },
  { src: '/images/project-3.jpg', caption: 'Recent Client Project — Seal Coating' },
  { src: '/images/project-4.jpg', caption: 'Recent Client Project — Paving Crew' },
  { src: '/images/project-5.jpg', caption: 'Recent Client Project — Commercial Lot' },
  { src: '/images/project-6.jpg', caption: 'Recent Client Project — Roadwork' },
  { src: '/images/project-7.jpg', caption: 'Recent Client Project — Crack Sealing' },
  { src: '/images/project-8.jpg', caption: 'Recent Client Project — Completed Driveway' },
  {
    src: 'https://images.unsplash.com/photo-1708117390188-d1547de962be?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200',
    caption: 'Paving Equipment in Action',
  },
  {
    src: 'https://images.unsplash.com/photo-1605146768851-eda79da39897?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200',
    caption: 'Residential Driveway',
  },
  {
    src: 'https://images.unsplash.com/photo-1506521781263-d8422e82f27a?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200',
    caption: 'Commercial Parking Lot',
  },
  {
    src: 'https://images.pexels.com/photos/36861831/pexels-photo-36861831.jpeg?auto=compress&cs=tinysrgb&w=1200',
    caption: 'Subdivision Repaving',
  },
  {
    src: 'https://images.unsplash.com/photo-1593280405106-e438ebe93f5b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200',
    caption: 'Finished Parking Area',
  },
  {
    src: 'https://images.unsplash.com/photo-1590938076771-dfe17af4d484?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200',
    caption: 'Line Painting Detail',
  },
  {
    src: 'https://images.pexels.com/photos/27937015/pexels-photo-27937015.jpeg?auto=compress&cs=tinysrgb&w=1200',
    caption: 'On-Site Crew at Work',
  },
  {
    src: 'https://images.unsplash.com/photo-1604275291560-55f54cec0e4d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200',
    caption: 'Parking Lot Striping',
  },
];

export const stats = [
  { value: '35+', label: 'Years in Business' },
  { value: '1988', label: 'Established' },
  { value: '2,500+', label: 'Projects Completed' },
  { value: '100%', label: 'Family Owned' },
];

export const testimonials = [
  {
    name: 'James R.',
    location: 'Calgary, AB',
    rating: 5,
    text: 'MW Stewart resurfaced our entire commercial lot in under a week. Professional, on-budget, and the finish looks fantastic.',
  },
  {
    name: 'Linda M.',
    location: 'Calgary, AB',
    rating: 5,
    text: 'They sealcoated our long rural driveway last summer and it still looks brand new. Honest, hardworking family business.',
  },
  {
    name: 'Property Manager — Westgate',
    location: 'Calgary, AB',
    rating: 5,
    text: 'We have used MW Stewart for crack sealing across 14 properties. Reliability is unmatched.',
  },
];
